import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "h6 text-fprimary text-uppercase" }
const _hoisted_2 = { class: "fs-5" }
const _hoisted_3 = { class: "row bg-light-info sticky-top" }
const _hoisted_4 = { class: "col-sm-6" }
const _hoisted_5 = { class: "p-2 fw-bolder text-uppercase d-inline-block" }
const _hoisted_6 = { class: "col-sm-2 text-center" }
const _hoisted_7 = { class: "p-2 fw-bolder text-uppercase d-inline-block" }
const _hoisted_8 = { class: "col-sm-2 text-center" }
const _hoisted_9 = { class: "p-2 fw-bolder text-uppercase d-inline-block" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "col-sm-2 text-center" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "p-2 fw-bolder text-uppercase d-inline-block" }, "Total")
], -1)
const _hoisted_11 = { class: "col-sm-6" }
const _hoisted_12 = { class: "p-2 d-inline-block" }
const _hoisted_13 = { class: "col-sm-2 text-center" }
const _hoisted_14 = {
  key: 1,
  class: "form-control form-control-solid d-block py-1 border my-2"
}
const _hoisted_15 = { class: "col-sm-2 text-center" }
const _hoisted_16 = {
  key: 1,
  class: "form-control form-control-solid d-block py-1 border my-2"
}
const _hoisted_17 = ["innerHTML"]
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "p-2 bg-white" }, null, -1)
const _hoisted_19 = { class: "h6 text-fprimary text-uppercase" }
const _hoisted_20 = { class: "table table-bordered w-100 border" }
const _hoisted_21 = { class: "text-center fw-bold text-uppercase" }
const _hoisted_22 = {
  rowspan: "2",
  colspan: "2",
  style: {"background-color":"#f8fdf8"}
}
const _hoisted_23 = {
  colspan: "3",
  class: "fw-bold",
  style: {"background-color":"#d6e8d6"}
}
const _hoisted_24 = { class: "text-center fw-bold text-uppercase" }
const _hoisted_25 = {
  class: "border",
  style: {"background-color":"#d6e8d6"}
}
const _hoisted_26 = {
  class: "border",
  style: {"background-color":"#d6e8d6"}
}
const _hoisted_27 = /*#__PURE__*/_createElementVNode("th", {
  class: "border px-2",
  style: {"background-color":"#d6e8d6"}
}, "TOTAL", -1)
const _hoisted_28 = {
  class: "border bg-success bg-opacity-10 text-end align-middle",
  colspan: "2"
}
const _hoisted_29 = { class: "border text-center" }
const _hoisted_30 = {
  key: 1,
  class: "form-control form-control-solid d-block bg-white py-1 border"
}
const _hoisted_31 = { class: "border text-center" }
const _hoisted_32 = {
  key: 1,
  class: "form-control form-control-solid d-block bg-white py-1 border"
}
const _hoisted_33 = ["innerHTML"]
const _hoisted_34 = { class: "bg-success bg-opacity-75 fw-bolder text-center" }
const _hoisted_35 = {
  class: "border text-end",
  colspan: "2"
}
const _hoisted_36 = { class: "" }
const _hoisted_37 = { class: "border" }
const _hoisted_38 = { class: "border" }
const _hoisted_39 = { class: "border" }
const _hoisted_40 = {
  colspan: "2",
  class: "border text-end bg-success bg-opacity-25"
}
const _hoisted_41 = { class: "border text-center" }
const _hoisted_42 = {
  key: 1,
  class: "form-control form-control-solid d-block bg-white py-1 border"
}
const _hoisted_43 = { class: "border text-center" }
const _hoisted_44 = {
  key: 1,
  class: "form-control form-control-solid d-block bg-white py-1 border"
}
const _hoisted_45 = ["innerHTML"]
const _hoisted_46 = { class: "bg-success bg-opacity-75 fw-bolder text-center" }
const _hoisted_47 = {
  class: "border text-end",
  colspan: "2"
}
const _hoisted_48 = { class: "" }
const _hoisted_49 = { class: "border" }
const _hoisted_50 = { class: "border" }
const _hoisted_51 = { class: "border" }
const _hoisted_52 = { class: "bg-success bg-opacity-75 fw-bolder text-center" }
const _hoisted_53 = {
  class: "border text-end",
  colspan: "2"
}
const _hoisted_54 = { class: "" }
const _hoisted_55 = ["innerHTML"]
const _hoisted_56 = ["innerHTML"]
const _hoisted_57 = { class: "border" }
const _hoisted_58 = { class: "card card-custom d-none" }
const _hoisted_59 = {
  class: "card-body",
  style: {"overflow-x":"auto","overflow-y":"auto"}
}
const _hoisted_60 = { class: "row" }
const _hoisted_61 = { class: "col-sm-12" }
const _hoisted_62 = { class: "h6 mb-5 text-fprimary" }
const _hoisted_63 = { class: "row" }
const _hoisted_64 = { class: "col-sm-12" }
const _hoisted_65 = { class: "h6 mb-5 text-fprimary" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")!
  const _component_el_collapse = _resolveComponent("el-collapse")!
  const _component_el_form = _resolveComponent("el-form")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_form, {
      ref: "formQRef",
      model: _ctx.formQ,
      rules: _ctx.rules
    }, {
      default: _withCtx(() => [
        _createElementVNode("h3", _hoisted_1, _toDisplayString(_ctx.t("qtitle1")), 1),
        _createElementVNode("p", null, _toDisplayString(_ctx.t("qtitle1Des")), 1),
        _createVNode(_component_el_collapse, {
          accordion: "",
          class: "border border-secondary rounded mb-5"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listItems.sports, (item, index) => {
              return (_openBlock(), _createBlock(_component_el_collapse_item, {
                key: `lst-${index}-a`,
                name: index
              }, {
                title: _withCtx(({ isActive }) => [
                  _createElementVNode("div", {
                    class: _normalizeClass(["el-collapse-item-custom p-4 fw-bolder d-flex align-items-center gap-3", { active: isActive }])
                  }, [
                    (item?.icon)
                      ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                          key: 0,
                          icon: ['fas', item?.icon],
                          size: "lg",
                          class: "rounded bg-white border-white text-info p-2"
                        }, null, 8, ["icon"]))
                      : _createCommentVNode("", true),
                    _createElementVNode("span", _hoisted_2, _toDisplayString(item.name), 1)
                  ], 2)
                ]),
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                      _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.t("categorie")), 1)
                    ]),
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.t("male")), 1)
                    ]),
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.t("female")), 1)
                    ]),
                    _hoisted_10
                  ]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.events, (mela, index2) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "row border-bottom bg-hover-light-info",
                      key: `mel${index2}s`
                    }, [
                      _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("span", _hoisted_12, _toDisplayString(mela.name), 1)
                      ]),
                      _createElementVNode("div", _hoisted_13, [
                        (_ctx.isAdminn)
                          ? (_openBlock(), _createBlock(_component_el_input, {
                              key: 0,
                              modelValue: mela.male,
                              "onUpdate:modelValue": ($event: any) => ((mela.male) = $event),
                              modelModifiers: { number: true },
                              placeholder: "0",
                              class: "w-100px input-total p-2 d-inline-block",
                              disabled: (mela.allowed == '1' || mela.allowed == '3') ? false : true,
                              onFocus: _ctx.handleFocus,
                              onBlur: (event) => _ctx.handleBlur(event, mela, 'male', mela.vmin, mela.vmax, mela.summation),
                              maxlength: "2"
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled", "onFocus", "onBlur"]))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              (_ctx.formQ.mstatus == 4)
                                ? (_openBlock(), _createBlock(_component_el_input, {
                                    key: 0,
                                    modelValue: mela.male,
                                    "onUpdate:modelValue": ($event: any) => ((mela.male) = $event),
                                    modelModifiers: { number: true },
                                    placeholder: "0",
                                    class: "w-100px input-total p-2 d-inline-block",
                                    disabled: (mela.allowed == '1' || mela.allowed == '3') ? false : true,
                                    onFocus: _ctx.handleFocus,
                                    onBlur: (event) => _ctx.handleBlur(event, mela, 'male', mela.vmin, mela.vmax, mela.summation),
                                    maxlength: "2"
                                  }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled", "onFocus", "onBlur"]))
                                : (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(mela.male), 1))
                            ], 64))
                      ]),
                      _createElementVNode("div", _hoisted_15, [
                        (_ctx.isAdminn)
                          ? (_openBlock(), _createBlock(_component_el_input, {
                              key: 0,
                              modelValue: mela.female,
                              "onUpdate:modelValue": ($event: any) => ((mela.female) = $event),
                              modelModifiers: { number: true },
                              placeholder: "0",
                              class: "w-100px input-total text-center p-2 d-inline-block",
                              disabled: (mela.allowed == '2' || mela.allowed == '3') ? false : true,
                              onFocus: _ctx.handleFocus,
                              onBlur: (event) => _ctx.handleBlur(event, mela, 'female', mela.vmin, mela.vmax, mela.summation),
                              maxlength: "2"
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled", "onFocus", "onBlur"]))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              (_ctx.formQ.mstatus == 4)
                                ? (_openBlock(), _createBlock(_component_el_input, {
                                    key: 0,
                                    modelValue: mela.female,
                                    "onUpdate:modelValue": ($event: any) => ((mela.female) = $event),
                                    modelModifiers: { number: true },
                                    placeholder: "0",
                                    class: "w-100px input-total text-center p-2 d-inline-block",
                                    disabled: (mela.allowed == '2' || mela.allowed == '3') ? false : true,
                                    onFocus: _ctx.handleFocus,
                                    onBlur: (event) => _ctx.handleBlur(event, mela, 'female', mela.vmin, mela.vmax, mela.summation),
                                    maxlength: "2"
                                  }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled", "onFocus", "onBlur"]))
                                : (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(mela.female), 1))
                            ], 64))
                      ]),
                      _createElementVNode("div", {
                        class: "col-sm-2 text-center p-2",
                        innerHTML: _ctx.calculateTotal(mela.male, mela.female)
                      }, null, 8, _hoisted_17)
                    ]))
                  }), 128)),
                  _hoisted_18
                ]),
                _: 2
              }, 1032, ["name"]))
            }), 128))
          ]),
          _: 1
        }),
        _createElementVNode("h3", _hoisted_19, _toDisplayString(_ctx.t("qtitle2")), 1),
        _createElementVNode("p", null, _toDisplayString(_ctx.t("qtitle2Des")), 1),
        _createElementVNode("table", _hoisted_20, [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", _hoisted_21, [
              _createElementVNode("th", _hoisted_22, _toDisplayString(_ctx.t("sports")), 1),
              _createElementVNode("th", _hoisted_23, _toDisplayString(_ctx.t("bygender")), 1)
            ]),
            _createElementVNode("tr", _hoisted_24, [
              _createElementVNode("th", _hoisted_25, _toDisplayString(_ctx.t("male")), 1),
              _createElementVNode("th", _hoisted_26, _toDisplayString(_ctx.t("female")), 1),
              _hoisted_27
            ])
          ]),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listItems.sports, (item, index) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: `lst-${index}-f`
              }, [
                _createElementVNode("td", _hoisted_28, _toDisplayString(item.name), 1),
                _createElementVNode("td", _hoisted_29, [
                  (_ctx.isAdminn)
                    ? (_openBlock(), _createBlock(_component_el_input, {
                        key: 0,
                        modelValue: item.otMen,
                        "onUpdate:modelValue": ($event: any) => ((item.otMen) = $event),
                        modelModifiers: { number: true },
                        placeholder: "0",
                        onFocus: _ctx.handleFocus,
                        onBlur: (event) => _ctx.handleBlurOf(event, item, 'otMen', item.allowed, item.otWomen),
                        class: "input-total text-center w-100px",
                        maxlength: "2"
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "onFocus", "onBlur"]))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        (_ctx.formQ.mstatus == 4)
                          ? (_openBlock(), _createBlock(_component_el_input, {
                              key: 0,
                              modelValue: item.otMen,
                              "onUpdate:modelValue": ($event: any) => ((item.otMen) = $event),
                              modelModifiers: { number: true },
                              placeholder: "0",
                              onFocus: _ctx.handleFocus,
                              onBlur: (event) => _ctx.handleBlurOf(event, item, 'otMen', item.allowed, item.otWomen),
                              class: "input-total text-center w-100px",
                              maxlength: "2"
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "onFocus", "onBlur"]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_30, _toDisplayString(item.otMen), 1))
                      ], 64))
                ]),
                _createElementVNode("td", _hoisted_31, [
                  (_ctx.isAdminn)
                    ? (_openBlock(), _createBlock(_component_el_input, {
                        key: 0,
                        modelValue: item.otWomen,
                        "onUpdate:modelValue": ($event: any) => ((item.otWomen) = $event),
                        modelModifiers: { number: true },
                        placeholder: "0",
                        onFocus: _ctx.handleFocus,
                        onBlur: (event) => _ctx.handleBlurOf(event, item, 'otWomen', item.allowed, item.otMen),
                        class: "input-total text-center w-100px",
                        maxlength: "2"
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "onFocus", "onBlur"]))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        (_ctx.formQ.mstatus == 4)
                          ? (_openBlock(), _createBlock(_component_el_input, {
                              key: 0,
                              modelValue: item.otWomen,
                              "onUpdate:modelValue": ($event: any) => ((item.otWomen) = $event),
                              modelModifiers: { number: true },
                              placeholder: "0",
                              onFocus: _ctx.handleFocus,
                              onBlur: (event) => _ctx.handleBlurOf(event, item, 'otWomen', item.allowed, item.otMen),
                              class: "input-total text-center w-100px",
                              maxlength: "2"
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "onFocus", "onBlur"]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_32, _toDisplayString(item.otWomen), 1))
                      ], 64))
                ]),
                _createElementVNode("td", {
                  class: "border bg-white text-center align-middle px-2",
                  innerHTML: _ctx.calculateTotal(item.otMen, item.otWomen)
                }, null, 8, _hoisted_33)
              ]))
            }), 128)),
            _createElementVNode("tr", _hoisted_34, [
              _createElementVNode("td", _hoisted_35, [
                _createElementVNode("h6", _hoisted_36, _toDisplayString(_ctx.t('totalOfficer1')), 1)
              ]),
              _createElementVNode("td", _hoisted_37, _toDisplayString(_ctx.otMen), 1),
              _createElementVNode("td", _hoisted_38, _toDisplayString(_ctx.otWomen), 1),
              _createElementVNode("td", _hoisted_39, _toDisplayString(_ctx.totalOT()), 1)
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listItems.officers, (ofi, index) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: `lst-${index}-of`
              }, [
                _createElementVNode("td", _hoisted_40, _toDisplayString(ofi.name), 1),
                _createElementVNode("td", _hoisted_41, [
                  (_ctx.isAdminn)
                    ? (_openBlock(), _createBlock(_component_el_input, {
                        key: 0,
                        modelValue: ofi.men,
                        "onUpdate:modelValue": ($event: any) => ((ofi.men) = $event),
                        modelModifiers: { number: true },
                        placeholder: "0",
                        onFocus: _ctx.handleFocus,
                        onBlur: (event) => _ctx.handleBlurOf(event, ofi, 'men', ofi.allowed, ofi.women),
                        class: "input-total text-center w-100px",
                        maxlength: "2"
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "onFocus", "onBlur"]))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        (_ctx.formQ.mstatus == 4)
                          ? (_openBlock(), _createBlock(_component_el_input, {
                              key: 0,
                              modelValue: ofi.men,
                              "onUpdate:modelValue": ($event: any) => ((ofi.men) = $event),
                              modelModifiers: { number: true },
                              placeholder: "0",
                              onFocus: _ctx.handleFocus,
                              onBlur: (event) => _ctx.handleBlurOf(event, ofi, 'men', ofi.allowed, ofi.women),
                              class: "input-total text-center w-100px",
                              maxlength: "2"
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "onFocus", "onBlur"]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_42, _toDisplayString(ofi.men), 1))
                      ], 64))
                ]),
                _createElementVNode("td", _hoisted_43, [
                  (_ctx.isAdminn)
                    ? (_openBlock(), _createBlock(_component_el_input, {
                        key: 0,
                        modelValue: ofi.women,
                        "onUpdate:modelValue": ($event: any) => ((ofi.women) = $event),
                        modelModifiers: { number: true },
                        placeholder: "0",
                        onFocus: _ctx.handleFocus,
                        onBlur: (event) => _ctx.handleBlurOf(event, ofi, 'women', ofi.allowed, ofi.men),
                        class: "input-total text-center w-100px",
                        maxlength: "2"
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "onFocus", "onBlur"]))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        (_ctx.formQ.mstatus == 4)
                          ? (_openBlock(), _createBlock(_component_el_input, {
                              key: 0,
                              modelValue: ofi.women,
                              "onUpdate:modelValue": ($event: any) => ((ofi.women) = $event),
                              modelModifiers: { number: true },
                              placeholder: "0",
                              onFocus: _ctx.handleFocus,
                              onBlur: (event) => _ctx.handleBlurOf(event, ofi, 'women', ofi.allowed, ofi.men),
                              class: "input-total text-center w-100px",
                              maxlength: "2"
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "onFocus", "onBlur"]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_44, _toDisplayString(ofi.women), 1))
                      ], 64))
                ]),
                _createElementVNode("td", {
                  class: "border bg-white text-center align-middle px-2",
                  innerHTML: _ctx.calculateTotal(ofi.men, ofi.women)
                }, null, 8, _hoisted_45)
              ]))
            }), 128)),
            _createElementVNode("tr", _hoisted_46, [
              _createElementVNode("td", _hoisted_47, [
                _createElementVNode("h6", _hoisted_48, _toDisplayString(_ctx.t('totalOfficer2')), 1)
              ]),
              _createElementVNode("td", _hoisted_49, _toDisplayString(_ctx.ofMen), 1),
              _createElementVNode("td", _hoisted_50, _toDisplayString(_ctx.ofWomen), 1),
              _createElementVNode("td", _hoisted_51, _toDisplayString(_ctx.totalOFDelegation()), 1)
            ]),
            _createElementVNode("tr", _hoisted_52, [
              _createElementVNode("td", _hoisted_53, [
                _createElementVNode("h6", _hoisted_54, _toDisplayString(_ctx.t('totalOfficer3')), 1)
              ]),
              _createElementVNode("td", {
                class: "border",
                innerHTML: _ctx.calculateTotal(_ctx.otMen, _ctx.ofMen)
              }, null, 8, _hoisted_55),
              _createElementVNode("td", {
                class: "border",
                innerHTML: _ctx.calculateTotal(_ctx.otWomen, _ctx.ofWomen)
              }, null, 8, _hoisted_56),
              _createElementVNode("td", _hoisted_57, _toDisplayString(_ctx.totalOT() + _ctx.totalOFDelegation()), 1)
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["model", "rules"]),
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_58, [
      _createElementVNode("div", _hoisted_59, [
        _createVNode(_component_el_form, {
          ref: "formQRef",
          model: _ctx.formQ,
          rules: _ctx.rules
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_60, [
              _createElementVNode("div", _hoisted_61, [
                _createElementVNode("h3", _hoisted_62, _toDisplayString(_ctx.t("qtitle1")), 1)
              ])
            ]),
            _createTextVNode(" " + _toDisplayString(_ctx.t("qtitle2")) + " ", 1),
            _createElementVNode("div", _hoisted_63, [
              _createElementVNode("div", _hoisted_64, [
                _createElementVNode("h3", _hoisted_65, _toDisplayString(_ctx.t("qtitle2")) + "​", 1)
              ])
            ])
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ])
    ])), [
      [_directive_loading, _ctx.loading]
    ])
  ], 64))
}